module.exports = __webpack_public_path__ + "static/media/acom_docente.ca2d199d.png";